import { render } from "./passport.vue?vue&type=template&id=67181a48&scoped=true"
import script from "./passport.vue?vue&type=script&lang=js"
export * from "./passport.vue?vue&type=script&lang=js"

import "./passport.vue?vue&type=style&index=0&id=67181a48&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-survey/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67181a48"]])

export default __exports__